

/**
 * Gift Wrapping - Grabs the selected options and add's them as the values on the
 * accordion block
 */
 class storesLocator extends HTMLElement {
    constructor() {
      super();
      this.navigation = this.querySelector('#stores-navigation');
      this.cityBlocks = this.querySelectorAll('.buly-stores-grid');
      this.initilizeButtons();
    }

    initilizeButtons() {
        const buttonTypes = this.getCityNames();
        const storesNavigation = this.navigation;
        let buttonArray = [];
        buttonTypes.forEach(function (value) {
            if(buttonArray.includes(value) != false) return;
            buttonArray.push(value);
            let newButton = document.createElement('button');
            newButton.setAttribute('type', 'button');
            newButton.setAttribute('value', value);
            newButton.setAttribute('class', 'store-button button button--tertiary no-shadow inline-block uppercase');
            newButton.innerText = value;
            storesNavigation.append(newButton);
        });
        
        const storeButtons = this.querySelectorAll('.store-button');
        storeButtons.forEach((storeButton) => storeButton.addEventListener('click', (e) => this.changeVisibleStores(e)));
    }

    getCityNames() {
        const cityArray = []
        Array.from(this.cityBlocks).forEach((city) => {
            let value = city.getAttribute('data-city');
            cityArray.push(value);
        });
        return cityArray;
    }

    changeVisibleStores(e) {
        const value = e.currentTarget.getAttribute('value');
        const storeButtons = this.querySelectorAll('.store-button');
        if(value == 'all') {
            Array.from(this.cityBlocks).forEach((city) => {
                city.classList.add('active');
            });
            storeButtons.forEach((storeButton) => storeButton.classList.remove('active'));
            e.currentTarget.classList.add('active');
        } else {
            Array.from(this.cityBlocks).forEach((city) => {
                let blockCity = city.getAttribute('data-city');
                if (value == blockCity) {
                    city.classList.add('active');
                    storeButtons.forEach((storeButton) => storeButton.classList.remove('active'));
                    e.currentTarget.classList.add('active');
                } else {
                    city.classList.remove('active');
                }
            });
        }
    }
  }
  
customElements.define('stores-locator', storesLocator);